<div class="d-flex m-5">
    <div *ngIf="identificadorCorrecto == 'valido' || identificadorCorrecto == ''" class="w-100 text-center identificadorValido">
        <h2>{{ 'CONFIRM_EMAIL.OK_TITLE' | translate }}</h2>
        <div class="w-100 justify-content-center d-flex">
            <h5>{{ 'CONFIRM_EMAIL.OK_BODY' | translate }}</h5>
        </div>
    </div>

    <div *ngIf="identificadorCorrecto == 'caducado'" class="w-100 text-center justify-content-center identificadorInvalido">
        <h2 class="text-warning">{{ 'CONFIRM_EMAIL.WARN' | translate }}</h2>
        <div class="w-100 justify-content-center d-flex flex-wrap mt-3">
            <h5 class="w-50" *ngIf="identificadorCorrecto == 'caducado'">{{ 'CONFIRM_EMAIL.EXPIRED' | translate }}</h5>
            <div class="w-100 mt-5">
                <button class="btn btn-primary" (click)="reenviarCorreo()" [disabled]="blockEnvioCorreo? 'true' : null">{{ 'CONFIRM_EMAIL.RESEND' | translate }}</button>
            </div>
        </div>
    </div>
    <div *ngIf="identificadorCorrecto == 'incorrecto'" class="w-100 text-center justify-content-center identificadorInvalido">
        <h2 class="text-warning">{{ 'CONFIRM_EMAIL.WARN' | translate }}</h2>
        <div class="w-100 justify-content-center d-flex flex-wrap mt-3">
            <h5 class="w-50" *ngIf="identificadorCorrecto == 'incorrecto'">{{ 'CONFIRM_EMAIL.INVALID' | translate }}</h5>
        </div>
    </div>
</div>
